export default {
  "content": "<path d=\"M7.704 20.707a1 1 0 01-1.414 0l-4-4 1.414-1.414 2.293 2.293V4h2v13.586l2.293-2.293 1.414 1.414-4 4zM13.997 15h6v2h-6v-2zM19.997 11h-8v2h8v-2zM11.997 7h8v2h-8V7z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};